module.exports = __webpack_public_path__ + "static/media/brook-preloader.fb6c3afc.gif";